import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var generateStyle = function generateStyle(componentTheme) {
  var mp = '@media print';
  return {
    root: _defineProperty({
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: componentTheme.rootBackgroundColor
    }, mp, {
      display: 'block'
    }),
    submitBar: _defineProperty({
      width: '90%',
      margin: componentTheme.submitBarMargin,
      marginBottom: componentTheme.submitBarMarginBottom,
      display: 'flex',
      justifyContent: 'flex-end',
      alignSelf: 'center',
      alignItems: 'center'
    }, mp, {
      display: 'none'
    }),
    continueToNextStudentWrapper: {
      marginRight: '2rem'
    },
    fudgePointsSection: {
      width: '90%',
      justifyContent: 'space-between',
      backgroundColor: componentTheme.fudgePointsSectionBackgroundColor,
      borderRadius: componentTheme.fudgePointsSectionBorderRadius,
      margin: componentTheme.fudgePointsSectionMargin,
      padding: componentTheme.fudgePointsSectionPadding,
      flex: '1 1 auto',
      display: 'flex',
      alignItems: 'center',
      alignSelf: 'center'
    },
    fudgePointsBox: {
      flex: '0 0 5rem',
      width: componentTheme.fudgePointsBoxWidth,
      padding: componentTheme.fudgePointsBoxPadding,
      margin: componentTheme.fudgePointsBoxMargin
    },
    fudgePointsLabel: {
      fontSize: componentTheme.fudgePointsLabelFontSize,
      fontWeight: componentTheme.fudgePointsLabelFontWeight
    },
    fudgeInfo: {
      flex: '1 1 auto',
      fontSize: componentTheme.fudgeInfoFontSize
    },
    finalScoreWrapper: {
      width: '90%',
      margin: componentTheme.finalScoreWrapperMargin,
      padding: componentTheme.finalScoreWrapperPadding,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      alignSelf: 'center'
    },
    finalScoreLabel: {
      flex: '1 1 auto',
      fontSize: componentTheme.finalScoreLabelFontSize,
      width: '90%'
    },
    finalScore: {
      flex: '1 1 5rem',
      textAlign: 'end',
      fontSize: componentTheme.finalScoreFontSize,
      fontWeight: componentTheme.finalScoreFontWeight
    }
  };
};
export default generateStyle;